import { useEffect, useRef } from "react";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const RED_ICON = new L.Icon({
  iconUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

export default function ParkMap({ sessions }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!elRef.current || mapRef.current) return;
    // Center on Sugar House, Salt Lake City
    const map = L.map(elRef.current).setView([40.7248, -111.8560], 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors", maxZoom: 18,
    }).addTo(map);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    const layer = L.layerGroup().addTo(map);
    const pts = [];
    (sessions || []).forEach((s) => {
      if (s.lat && s.lng) {
        L.marker([s.lat, s.lng], { icon: RED_ICON })
          .addTo(layer)
          .bindPopup(`<strong>${s.park_name}</strong><br>${s.date} · ${s.time}`);
        pts.push([s.lat, s.lng]);
      }
    });
    if (pts.length) map.fitBounds(pts, { padding: [40, 40], maxZoom: 13 });
    setTimeout(() => map.invalidateSize(), 200);
    return () => { layer.remove(); };
  }, [sessions]);

  return <div ref={elRef} className="w-full h-[420px] rounded-2xl overflow-hidden border border-brand-line relative z-0" data-testid="park-map" />;
}
